import { HttpMethod } from "../common/lib/fetch/useFetch";
import { RequestOptions } from "../common/lib/fetch/useRequest";
import useUserRequest from "../common/lib/fetch/useUserRequest";
import { useUser } from "../userAccess/useUser";

export interface CarrierDriverSettings {
  requireCarrierNumber: boolean;
  requireTransportNumber: boolean;
  requireDriverNumber: boolean;
  requireDriverPassword: boolean;
}

export default function useUpdateCarrierDriverSettings(options?: RequestOptions) {
  const user = useUser();

  return useUserRequest<CarrierDriverSettings>({
    path: `/api/sites/${user.selectedSite!.id}/carrierDriverSettings`,
    method: HttpMethod.PUT
  }, options)
}
